import { APIFetchError } from '@nbx/frontend-helpers/fetch-api';

// Only the server can end a session: a rejection carrying no response means we never got an answer.
export const isSessionRejected = (error: unknown): boolean => {
  if (!(error instanceof APIFetchError)) return false;
  const status = error.response?.status;
  return status === 401 || status === 403;
};

// Enough for a suspend/resume or a lost cell handover, short enough not to stall the caller.
export const TRANSIENT_RETRY_DELAYS_MS = [1000, 3000];

export const wait = (ms: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });
